import { render } from "./Download.vue.js?vue&type=template&id=714924ef!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Download.vue?vue&type=template&id=714924ef"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__